/**
 * Función que realiza envió a dirección url enviada en parametros
 * @param url string que contiene la URL a la que será redirigido
 */
export const irAUrl = (url: string) => {
  window.open(url, '_blank');
};
